import { useMutation, useQueryClient } from "@tanstack/react-query";
import { merchantEmployeesKeys } from "Api/Queries/Merchants/Employees/useMerchantEmployees";
import {
  type CreateEmployeeRequest,
  type EmployeeDto,
  postMerchantsPublicIDEmployees,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: (employee: EmployeeDto) => void;
  onError?: (error: unknown) => void;
};

type Parameters = {
  data: CreateEmployeeRequest;
  merchantPublicID: string;
};

export const useCreateEmployeeMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ data, merchantPublicID }: Parameters) =>
        postMerchantsPublicIDEmployees(data, merchantPublicID),
    ),
    onSuccess: (data: EmployeeDto) => {
      // The list page queries without a merchant id, so invalidate every list, not list(publicID).
      queryClient.invalidateQueries({
        queryKey: merchantEmployeesKeys.lists(),
      });
      onSuccess?.(data);
    },
    onError,
  });
};
